module.exports = __webpack_public_path__ + "static/media/card-logo-amex.8a8319bb.svg";